const colors = {
  black: "#000000",
  white: "#ffffff",
  transparent: "transparent",
  "gray-25": "#FCFCFD",
  "gray-50": "#F9FAFB",
  "gray-100": "#F2F4F7",
  "gray-200": "#EAECF0",
  "gray-300": "#D0D5DD",
  "gray-400": "#98A2B3",
  "gray-500": "#667085",
  "gray-600": "#475467",
  "gray-700": "#344054",
  "gray-800": "#1D2939",
  "gray-900": "#101828",
  "gray-950": "#0C111D",
  "primary-25": "#FEFAF5",
  "primary-50": "#FEF6EE",
  "primary-100": "#FDEAD7",
  "primary-200": "#F9DBAF",
  "primary-300": "#F7B27A",
  "primary-400": "#F38744",
  "primary-500": "#EF6820",
  "primary-600": "#E04F16",
  "primary-700": "#B93815",
  "primary-800": "#932F19",
  "primary-900": "#772917",
  "primary-950": "#511C10",
  "error-300": "#FDA29B",
  "error-500": "#F04438",
  "warning-500": "#F79009",
  "success-500": "#17B26A",
} as const;

type Color = keyof typeof colors;

export { type Color, colors };
